<script lang="ts">
  import Panel from '@components/panel.svelte'
  import {
    getTeamIdFromNhlEvent,
    ordinalNumber,
    tokensToText,
    type GameraTeamReference,
    type NhlEvent,
  } from '@statmuse/core/gamera'
  import { plays } from './stores'
  import { first } from 'lodash-es'

  export let play: NhlEvent
  export let awayTeam: GameraTeamReference | undefined
  export let homeTeam: GameraTeamReference | undefined

  $: team =
    awayTeam?.teamId === getTeamIdFromNhlEvent(play)
      ? awayTeam
      : homeTeam?.teamId === getTeamIdFromNhlEvent(play)
      ? homeTeam
      : undefined

  $: firstPlayOfCurrentPeriod = first(
    $plays.filter((p) => p.period === play.period),
  )

  $: isShootout = firstPlayOfCurrentPeriod?.clock === '00:00'
</script>

<Panel
  background={team?.colors?.backgroundColor}
  foreground={team?.colors?.foregroundColor}
>
  <div class="flex items-center gap-1">
    <div class="flex-1">
      {#if play.type === 'endPeriod'}
        <p>
          End of {isShootout
            ? 'Shootout'
            : play.period <= 3
            ? ordinalNumber(play.period)
            : `${play.period >= 5 ? play.period - 3 : ''}OT`}
        </p>
      {:else}
        <p>{tokensToText(play.description)}</p>
      {/if}
    </div>
    <div class="text-sm text-right">
      {#if isShootout}
        <p>Shootout</p>
      {:else}
        <p>
          {play.period < 4
            ? ordinalNumber(play.period)
            : play.period > 4
            ? `${play.period - 3}OT`
            : 'OT'}
          {play.clock ?? ''}
        </p>
      {/if}
      {#if play.awayPoints !== undefined && play.homePoints !== undefined}
        <p class="opacity-50">
          {play.shotContext === 'shootout'
            ? play.awayShootoutScore
            : play.awayPoints}-{play.shotContext === 'shootout'
            ? play.homeShootoutScore
            : play.homePoints}
        </p>
      {/if}
    </div>
  </div>
</Panel>
